import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">编辑精选</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门推荐</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">编辑团队每日精选的高分漫画，覆盖国漫日漫韩漫热门作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <a key={card.id} href="#ranking" className="group block cursor-pointer no-underline">
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-100">
                <img
                  src={card.image}
                  alt={`${card.title} - ${card.tag}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).classList.add('hidden');
                  }}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded">{card.tag}</span>
                </div>
              </div>
              <h3 className="font-heading font-bold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">{card.title}</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{card.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}